import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  PlacementWithLogical,
  Text,
} from "@chakra-ui/react"
import { CCheckmark, CChevronDown, CChevronUp } from "./Icons"

type Props = {
  menuOptions: { name: string; value: string }[]
  selectedOption: string
  menuTitle: string
  matchWidth?: boolean
  placement?: PlacementWithLogical
  handleSelect: (value: string) => void
  buttonMaxW?: string
  optionsMaxW?: string
  buttonMinW?: string
}

/* Pass an empty menuTitle to render a single line normal font title, otherwise it will be double line title with bold second line */
const MenuFilter = ({
  menuOptions,
  selectedOption,
  menuTitle,
  matchWidth = false,
  placement = "bottom-start",
  handleSelect,
  buttonMaxW = "150",
  optionsMaxW = "150",
  buttonMinW = "auto",
}: Props) => {
  const selected = menuOptions.find((option) => option.value === selectedOption) ?? menuOptions[0]

  return (
    <Menu autoSelect={false} gutter={0} isLazy matchWidth={matchWidth} placement={placement}>
      {({ isOpen }) => (
        <>
          <MenuButton
            px="2"
            as={Button}
            fontSize={menuTitle ? "2xs" : "sm"}
            rightIcon={isOpen ? <CChevronUp /> : <CChevronDown />}
            textAlign="left"
            iconSpacing="4"
            maxW={buttonMaxW}
            minW={{ base: "100%", sm: buttonMinW }}
            h={{ base: "11", md: "10" }}
            w={{ base: "100%", sm: "auto" }}
            variant="dropdown"
          >
            <Text fontWeight="normal">{menuTitle}</Text>
            <Text textOverflow="ellipsis" overflow="hidden" fontWeight={menuTitle ? "bold" : "normal"}>
              {selected.name}
            </Text>
          </MenuButton>
          <MenuList
            maxH="88"
            overflowY="auto"
            w={{ base: "calc(100vw - 32px)", xs: "calc(100vw - 48px)", sm: "auto" }}
            maxW={{ base: "calc(100vw - 32px)", xs: "calc(100vw - 48px)", sm: optionsMaxW }}
            shadow="md"
          >
            <MenuOptionGroup type="radio" defaultValue={selected.value} onChange={handleSelect} w="min-content">
              {menuOptions.map((option) => {
                return (
                  <MenuItemOption
                    key={option.value}
                    icon={<CCheckmark />}
                    isChecked={option.value === selected.value}
                    color={option.value === selected.value ? "brand.500" : "black"}
                    value={option.value}
                    h="100%"
                    minH={{ base: "11", md: "10" }}
                    mb={{ base: "2", md: "0" }}
                    fontSize="sm"
                    iconSpacing="2.5"
                    px="2.5"
                    fontWeight="medium"
                  >
                    <Text noOfLines={1}>{option.name}</Text>
                  </MenuItemOption>
                )
              })}
            </MenuOptionGroup>
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default MenuFilter
